import { render, staticRenderFns } from "./books-normal.vue?vue&type=template&id=005c3c4c&scoped=true&"
import script from "./books-normal.vue?vue&type=script&lang=js&"
export * from "./books-normal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005c3c4c",
  null
  
)

export default component.exports